/**
 * Governance Main component housing nested components and handling all events.
 * It displays governance categories TreeView and related documents.
 * It aslo contains TreeRow component loaded by function outerNode
 * Nested components: TreeView.js and GovernanceDocuments.js
 * This component is loaded by clicking the Governance/Library tab in the ContentMenu.js (nav bar)
 */

import React from 'react';
import store from '../../../../../stores/store';
// import SortableTree from 'react-sortable-tree';
import TreeView from '../../../../_shared/TreeView';
import GovernanceDocuments from './GovernanceDocuments';

import _ from 'lodash';
import { observer } from 'mobx-react';
// load css styles
import './governance.css';
import { DOC_TYPE_GOVERNANCE } from '../../../../../helpers/constants';
import { Collapse, Button } from 'reactstrap';
import { action, extendObservable } from 'mobx';
// import { getUnix } from '../../../../../helpers/utils';
import * as local from '../../../../../helpers/localStorage';
import {
    // ERROR_OPEN_DOCUMENT_MSG,
    // ERROR_OPEN_DOCUMENT_TITLE,
    // DOC_TOKEN_ERROR_HEADER_MSG,
    // DOC_TOKEN_ERROR_CONTENT_MSG,
    DOC_NOTDOWNLOADED_MSG,
    // DOC_NOTDOWNLOADED_TITLE,
} from '../../../../../helpers/messageText';

const TreeRow = observer(
    class TreeRow extends React.Component {
        render() {
            return (
                <div
                    className={
                        '' +
                        (this.props.item.Id === store.groups.selectedGovCatId
                            ? 'selected-category'
                            : 'not-selected-category')
                    }
                >
                    {this.props.content}
                </div>
            );
        }
    },
);

const Governance = observer(
    class Governance extends React.Component {
        constructor(props) {
            super(props);
            //  this.state = { collapse: true };

            var displayButtonStatus = 'none';
            if (window.offlineApiExtension && store.conn.isOnline) {
                displayButtonStatus = '';
            }

            this.state = {
                showDocumentModal: false,
                currentDocumentBlob: null,
                displayButton: displayButtonStatus,
                displayPercentage: 'none',
                percentageBar: '0',
            };
            this.form = extendObservable(this, {
                collapse: true,
                set: action((field, value) => {
                    this[field] = value;
                }),
            });
        }

        toggle = () => {
            this.form.set('collapse', !this.form.collapse);
        };

        updateDimensions = () => {
            if (window.innerWidth > 768) {
                this.form.set('collapse', true);
            }
        };

        componentDidMount() {
            this.updateDimensions(this);
            window.addEventListener('resize', this.updateDimensions);
        }

        /**
         * Remove event listener
         */
        componentWillUnmount() {
            window.removeEventListener('resize', this.updateDimensions);
        }

        // TREE FUNCTIONS
        /**
         * The title to be displayed, or any other composition of react components
         * @param  {object} item The object returned by getNodes()
         * @return {any}         String to be displayed as a title or a react component
         */
        innerNode = item => {
            return item.CategoryName;
        };

        /**
         * React component that will wrap the node link. It will include 2 columns to be displayed
         * using Twitter Bootstrap to make it responsive
         * @param  {Component} content 	The react element containing the plus/leaf button and the title
         * @param  {object} item    	The object linked to the node (returned by getNodes)
         * @return {Component}         	A new component wrapping the given component
         */
        outerNode = (content, item) => {
            return (
                <TreeRow isExpandable="true" key={item.GovCatId} item={item} content={content} />
            );
        };

        /**
         * Inform the tree if the node is a leaf, i.e, if the node has no other children
         * @param  {object} item The object linked to the node, created by the <code>getNodes</code> function
         * @return {boolean}     return true if the node is a leaf
         */
        checkLeaf = item => {
            if (item.children) {
                return false;
            } else {
                return true;
            }
        };

        // MOUSE CLICK ACTIONS
        /**
         * It runs on selection of a category
         * @param  {object} item The object returned by getNodes()
         * @return {any}         String to be displayed as a title or a react component
         */
        onContentClick = item => {
            store.groups.changeSelectedGovCatId(item.item.GovCatId);
        };

        /**
         * It runs on selection of a document in the CustomRow.js compontent
         * nested in the GovernanceDocuments.js component. It calls func in
         * the groups store.
         * @param  {number} Id governance document Id
         */
        onDocumentClick = (Id, DocExtension, DocPermissions, DocName, DocAnnotations) => {
            let instanceId = store.companies.selectedCompany.InstanceId;
            const key =
                local.LS_GOVERNANCE_DOWNLOADED +
                instanceId +
                store.groups.selectedGroup.GroupId +
                store.user.profile[0].UserId;

            store.documents
                .fetchDocument({
                    instanceId,
                    docTypeId: DOC_TYPE_GOVERNANCE,
                    docId: Id,
                    DocExtension,
                    DocPermissions,
                    DocName,
                    DocAnnotations,
                })
                .then(res => {
                    if (res) {
                        // console.log('Governance opened doc');
                        store.groups.makeDocumentRead(Id);

                        // We save this key when downloaded
                        local.saveNumberByKeyStringInLocalStorageArray(key, Id);

                        store.groups.changeSelectedGovCatId(
                            store.groups.selectedGovernanceCategory.GovCatId,
                        );
                    }
                })
                .catch(error => {
                    console.log('error fetching doc - governance');
                });
        };

        onClickDownloadAll = async () => {
            let instanceId = store.companies.selectedCompany.InstanceId;
            let Id = store.groups.selectedGovCatId;

            const group = store.groups.selectedGroup;
            var context = this;

            store.groups.setIsDownloading(1);

            this.setState({
                displayButton: 'none',
                displayPercentage: '',
                percentageBar: '0',
            });

            // If nothing is selected then we return the top
            if (Id == null) {
                Id = group.governanceCategories[0].GovCatId;
            }

            // We get top level cat id
            let category = _.find(group.governanceCategories, c => {
                return c.GovCatId === Id;
            });
            let allCategories = [];
            allCategories.push(category);

            // We get second level cat ID
            let children = _.filter(group.governanceCategories, g => {
                return g.ParentId === category.GovCatId;
            });

            if (children.length > 0) {
                children.forEach(function(child) {
                    allCategories.push(child);

                    let secChildren = _.filter(group.governanceCategories, g => {
                        return g.ParentId === child.GovCatId;
                    });
                    if (secChildren.length > 0) {
                        secChildren.forEach(function(secChild) {
                            allCategories.push(secChild);
                        });
                    }
                });
            }

            // Ok we have all the cat ID we need for that level.. we now check for docos

            var totalDocumentCount = 0;
            var documentDownloadedCount = 0;

            // We first have to get a count of how many document we have to download
            allCategories.forEach(function(cat) {
                for (let i = 0; i <= cat.GovernanceDocs.length - 1; i++) {
                    totalDocumentCount++;
                }
            });

            const key =
                local.LS_GOVERNANCE_DOWNLOADED +
                instanceId +
                group.GroupId +
                store.user.profile[0].UserId;

            // OK we now start the process for downloading
            allCategories.forEach(async function(cat) {
                for (var governanceDocItem of cat.GovernanceDocs) {
                    // We await for the document to download before continue to bexr
                    let result = await store.documents.downloadDocumentOnly({
                        instanceId,
                        docTypeId: DOC_TYPE_GOVERNANCE,
                        docId: governanceDocItem.GovDocId,
                        DocExtension: governanceDocItem.DocExtension,
                        DocPermissions: governanceDocItem.DocPermissions,
                        DocName: governanceDocItem.DocName,
                        DocAnnotations: governanceDocItem.DocAnnotations,
                    });

                    // This should happen only when document has been downloaded and, therefore, idb fails to retrieve document

                    if (result == null) {
                        // console.log('not downloaded.');
                        throw new Error(DOC_NOTDOWNLOADED_MSG);
                    } else {
                        documentDownloadedCount++;

                        // We save this key when downloaded
                        local.saveNumberByKeyStringInLocalStorageArray(
                            key,
                            governanceDocItem.GovDocId,
                        );

                        // console.log(Math.round(documentDownloadedCount / totalDocumentCount * 100));

                        context.setState({
                            percentageBar:
                                Math.round(documentDownloadedCount / totalDocumentCount * 100) +
                                '%',
                        });

                        if (Id === governanceDocItem.GovCatId) {
                            store.groups.changeSelectedGovCatId(governanceDocItem.GovCatId);
                        }
                    }
                }

                if (documentDownloadedCount === totalDocumentCount) {
                    // When finished display the button again
                    context.setState({
                        displayButton: '',
                        displayPercentage: 'none',
                    });

                    store.groups.setIsDownloading(0);
                }
            });
        };

        buildDownloadButton = isOnline => {
            // console.log(store.user.tab);

            if (window.offlineApiExtension) {
                if (isOnline) {
                    return (
                        <button
                            type="button"
                            className="btn btn-outline-secondary ml-2"
                            id="downloadAllGovernance"
                            onClick={() => {
                                this.onClickDownloadAll();
                            }}
                        >
                            <i className="fa fa-download mr-2" aria-hidden="true" />Download
                            documents
                        </button>
                    );
                } else {
                    return (
                        <button className="btn btn-secondary disabled ml-auto" type="button">
                            <i className="fa fa-exclamation" aria-hidden="true" />
                            <span className="pl-3">OFFLINE</span>
                        </button>
                    );
                }
            }
        };

        // RENDER FUNCTION
        render() {
            // console.log('Governance render')

            return (
                <div className="document-tree-nav" id="document-tree">
                    <div className="d-flex flex-wrap justify-content-end mr-2 mb-2">
                        <div className="col ml-3 mt-1">
                            <h6>
                                {store.groups.selectedGroup
                                    ? store.groups.selectedGroup.GovernanceTitle
                                    : ''}
                            </h6>
                        </div>
                        {this.buildDownloadButton(store.conn.isOnline)}

                        <div
                            className="progress ml-2"
                            style={{ display: this.state.displayPercentage }}
                        >
                            <div
                                className="progress-bar"
                                role="progressbar"
                                aria-valuenow="25"
                                aria-valuemin="0"
                                aria-valuemax="100"
                                style={{ width: this.state.percentageBar }}
                            >
                                {this.state.percentageBar}
                            </div>
                        </div>
                    </div>
                    <Button
                        color="white"
                        onClick={this.toggle}
                        className="btn btn-sm btn-outline-secondary hidden-md-up mb-2"
                    >
                        <i className="fa fa-folder-o icon-padding" aria-hidden="true" />
                        Show / Hide folders
                    </Button>
                    <div className="d-flex flex-row folder-list-row mb-3">
                        <Collapse isOpen={this.form.collapse}>
                            <div
                                id="folder-grid"
                                className="width collapse show"
                                aria-expanded="true"
                            >
                                <div className="folder-list pl-0">
                                    <div className="list-width" id="folder-list">
                                        <TreeView
                                            onGetNodes={store.groups.getNodes}
                                            innerRender={this.innerNode}
                                            checkLeaf={this.checkLeaf}
                                            outerRender={this.outerNode}
                                            onContentClick={this.onContentClick}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Collapse>
                        <GovernanceDocuments onDocumentClick={this.onDocumentClick} />
                    </div>
                </div>
            );
        }
    },
);
export default Governance;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Dashboard/components/Governance/Governance.js